<template>
  <!-- Create a modal for a new user to register -->
  <div class="modal is-active">
    <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Register New User</p>
          <button class="delete" aria-label="close" @click="$emit('close')"></button>
        </header>
        <section class="modal-card-body">
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Name:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control is-expanded">
                  <input class="input"
                    type="text"
                    id="firstName"
                    placeholder="First Name"
                    v-model="firstName"
                    required>
                </div>
              </div>
              <div class="field">
                <div class="control is-expanded">
                  <input class="input"
                    type="text"
                    id="lastName"
                    placeholder="Last Name"
                    v-model="lastName"
                    required>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Username:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control is-expanded has-icons-left">
                  <input class="input"
                    type="text"
                    id="username"
                    placeholder="Username"
                    :value="username.toLowerCase()"
                    @input="username = $event.target.value.toLowerCase()"
                    @keyup="checkUsername"
                    required>
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                </div>
              </div>
              <div class="field">
                <div class="control is-expanded">
                  <b class="help is-success" v-if="usernameAvailable">
                    @{{username}} is available
                  </b>

                  <b class="help is-danger" v-if="!usernameAvailable">
                    @{{username}} has already been taken
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Email:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input class="input"
                    type="email"
                    id="registerEmail"
                    placeholder="Email"
                    v-model="email"
                    required>
                    <span class="icon is-small is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Password:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control is-expanded has-icons-left">
                  <input class="input"
                    type="password"
                    id="password"
                    placeholder="Password"
                    v-model="password"
                    required>
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                </div>
              </div>
              <div class="field">
                <div class="control is-expanded has-icons-left">
                  <input class="input"
                    type="password"
                    id="confirmPassword"
                    placeholder="Confirm Password"
                    v-model="confirmPassword"
                    @keyup="comparePasswords"
                    required>
                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                </div>
              </div>
              <div class="field">
                <div class="control is-expanded">
                  <b class="help is-success" v-if="passwordsNotMatch">
                    Passwords match
                  </b>

                  <b class="help is-danger" v-if="!passwordsNotMatch">
                    Passwords do not match
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">DOB:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input class="input"
                     type="date"
                     id="dob"
                     placeholder="Date of Birth"
                     v-model="dob"
                     required>
                     <span class="icon is-small is-left">
                       <i class="fas fa-calendar"></i>
                     </span>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Gender:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="select">
                    <select v-model="gender">
                      <option disabled selected value="">Select Gender</option>
                      <option>Male</option>
                      <option>Female</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="field-label">
              <label class="label">Race:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="select">
                    <select v-model="race">
                      <option disabled selected value="">Select One</option>
                      <option>White</option>
                      <option>African American</option>
                      <option>Hispanic</option>
                      <option>Native American</option>
                      <option>Asian</option>
                      <option>Other</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Height:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input class="input"
                    id="feet"
                    type="number"
                    min="0"
                    step="1"
                    placeholder="Feet"
                    v-model="feet"
                    required>
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input class="input"
                    id="inches"
                    type="number"
                    min="0"
                    max="11"
                    step="1"
                    placeholder="Inches"
                    v-model="inches"
                    required>
                </div>
              </div>
            </div>
            <div class="field-label">
              <label class="label">Weight:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <input class="input"
                    type="number"
                    id="weight"
                    placeholder="Weight"
                    v-model="weight"
                    required>
                </div>
              </div>
            </div>
          </div>
          <div class="field is-horizontal">
            <div class="field-label">
              <label class="label">Zipcode:</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control has-icons-left">
                  <input class="input"
                    type="number"
                    id="zipcode"
                    placeholder="Zipcode"
                    v-model="zipcode"
                    required>
                    <span class="icon is-small is-left">
                      <i class="fas fa-globe"></i>
                    </span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
            <div class="field is-grouped">
              <div class="control">
                <!-- Disables submit button until T&C are accepted.  Terms & conditions are a link -->
                <input type="checkbox" id="checkbox" v-model="checked">
                  <label for="checkbox" style="color: white">Accept
                    <button class="as-text" @click="showToCModal=true" style="color: white">
                    <u>Terms and Conditions</u></button> and
                    <button class="as-text" @click="showPrivacyModal=true" style="color: white">
                    <u>Privacy Policy</u></button>
                  </label>
                <button @click="register" class="button is-medium is-fullwidth">Submit</button>
                <ToCModal v-show="showToCModal" @close="showToCModal = false" @event_TOC="toastErr($event, failTOC)"></ToCModal>
                <PrivacyModal v-show="showPrivacyModal" @close="showPrivacyModal = false" ></PrivacyModal>
              </div>
            </div>
        </footer>
      </div>
    </div>
</template>


<script>
  import firebase from 'firebase'
  import ToCModal from "./ToCModal.vue"
  import PrivacyModal from "./PrivacyModal.vue"
  import debounce from 'lodash/debounce';

  export default {
    name: 'registerModal',
    components: {
      ToCModal: ToCModal,
      PrivacyModal: PrivacyModal
    },
    data() {
      return {
        failTOC: 'Please accept the Terms and Conditions and Privacy Policy to continue.',
        usernameAvailable: true,
        checked: '',
        firstName: '',
        lastName: '',
        username: '',
        email: '',
        password: '',
        dob: '',
        gender: '',
        race: '',
        weight: '',
        feet: '',
        inches: '',
        zipcode: '',
        showToCModal: false,
        showPrivacyModal: false,
        confirmPassword: '',
        passwordsNotMatch: false
      }
    },
    methods: {
      //If T&C not accepted deliver message to user
      toastErr(bool, message){
        this.checked = bool;
        this.showToCModal = false;
        if(!bool){
          this.$toasted.show(message, {
            theme: "outline",
            position: "bottom-center",
            duration : 3000,
            fitToScreen: true
          })
        }
      },

      //Check username to make sure it is unique using debounce
      //debounce is a function provided by lodash to limit how
      //often a particularly expensive operation can be run.
      //In this case, we want to limit how often we access
      //the firebase database, waiting until the user has completely
      //finished typing before making the request.
      checkUsername:debounce( function() {
        firebase.database().ref('users').once('value')
          .then((data) => {
            const obj = data.val()  // store all objects
            for (let key in obj) {
              if(obj[key].username == this.username){
                this.usernameAvailable = false
                return;
              }
            }
            this.usernameAvailable = true
          })
        },
        // This is the number of milliseconds we wait for the
        // user to stop typing.
      500),

      //Ensure user enters same password in both input fields
      comparePasswords:debounce( function() {
        return (this.passwordsNotMatch = (this.password == this.confirmPassword))
      },
      500),

      //Register new user with firebase authentication
      register() {
        if (document.getElementById('checkbox').checked==false) {
          this.toastErr(false, this.failTOC)
        } else {
          if (this.usernameAvailable==false || this.passwordsNotMatch==false) {
            if(this.usernameAvailable==false) {
              this.toastErr(false, 'Username Unavailable')
            } else if (this.passwordsNotMatch==false) {
              this.toastErr(false, 'Passwords Do Not Match')
            }
          } else {
            this.$store.dispatch('signUserUp', {
              firstName: this.firstName,
              lastName: this.lastName,
              username: this.username,
              email: this.email,
              password: this.password,
              dob: this.dob,
              gender: this.gender,
              race: this.race,
              weight: this.weight,
              feet: this.feet,
              inches: this.inches,
              zipcode: this.zipcode
            })
          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/Registration/registerModal.vue